<app-toast-container />
@if (innerWidth > 374 || allowSmallScreens) {
	<!-- vertical-layout -->
	@if (coreConfig?.layout?.type === 'vertical') {
		<vertical-layout [class]="layout"></vertical-layout>
	}
	<!-- / vertical-layout -->
	<!-- horizontal-layout -->
	@if (coreConfig?.layout?.type === 'horizontal') {
		<horizontal-layout [class]="layout"></horizontal-layout>
	}
	<!-- / horizontal-layout -->
	<ngx-spinner bdColor="rgba(0,0,0,0.8)" size="medium" color="#ffffff" type="ball-atom" [fullScreen]="true">
		<p style="color: white">{{ 'common_label_loading' | translate }}</p>
	</ngx-spinner>
} @else {
	<div class="container-fluid mt-5" style="height: 100%">
		<div class="w-100 m-auto align-middle pt-5" align="center">
			<fa-icon icon="warning" class="text-danger" size="5x"></fa-icon>
			<br />
			<h3 class="mt-4">{{ 'common_label_screen_too_small_text' | translate }}</h3>
		</div>
	</div>
}
